var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.657 20H3.343A3.351 3.351 0 0 1 0 16.657V3.343A3.351 3.351 0 0 1 3.343 0h13.314A3.351 3.351 0 0 1 20 3.343v13.314A3.34 3.34 0 0 1 16.657 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.005 15.138a5.1 5.1 0 0 1-3.63-1.503 5.1 5.1 0 0 1-1.504-3.63 5.1 5.1 0 0 1 1.503-3.63 5.1 5.1 0 0 1 3.63-1.504 5.1 5.1 0 0 1 3.631 1.503 5.1 5.1 0 0 1 1.503 3.63 5.1 5.1 0 0 1-1.503 3.631 5.115 5.115 0 0 1-3.63 1.503Zm0-9.175a4.043 4.043 0 0 0-4.042 4.042 4.043 4.043 0 0 0 4.042 4.04 4.043 4.043 0 0 0 4.04-4.04c-.008-2.226-1.815-4.042-4.04-4.042ZM16.138 4.702a.986.986 0 1 0 0-1.971.986.986 0 0 0 0 1.97Z",
    fill: "#fff"
  })));
};
export default SvgInstagram;